module.exports = __webpack_public_path__ + "static/media/stock.5cd1c09f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/web_apps/stock.png
// module id = 137
// module chunks = 0